import React, { useState, useEffect } from 'react';
import FacilitiesHeroForm from './FacilitiesHeroForm';
import FacilitiesOverviewForm from './FacilitiesOverviewForm';
import FacilitiesOverviewDetailForm from './FacilitiesOverviewDetailForm';
import FacilitiesTechForm from './FacilitiesTechForm';
import FacilitiesTechDetailForm from './FacilitiesTechDetailForm';
import FacilitiesSafetyForm from './FacilitiesSafetyForm';
import FacilitiesGalleryForm from './FacilitiesGalleryForm';
import FacilitiesTourForm from './FacilitiesTourForm';
import { 
  Building, 
  Building2, 
  Cpu, 
  ShieldCheck, 
  Images, 
  Compass,
  Layers,
  Sparkles
} from 'lucide-react';
import './FormsUnified.css';

const TABS = [
  { id: 'hero', title: 'Hero Section', icon: Building, component: FacilitiesHeroForm },
  { id: 'overview', title: 'Campus Overview', icon: Building2, component: FacilitiesOverviewForm },
  { id: 'overview-details', title: 'Overview Details', icon: Layers, component: FacilitiesOverviewDetailForm },
  { id: 'tech', title: 'Tech & Innovation', icon: Cpu, component: FacilitiesTechForm },
  { id: 'tech-details', title: 'Tech Details', icon: Sparkles, component: FacilitiesTechDetailForm },
  { id: 'safety', title: 'Safety & Security', icon: ShieldCheck, component: FacilitiesSafetyForm },
  { id: 'gallery', title: 'Photo Gallery', icon: Images, component: FacilitiesGalleryForm },
  { id: 'tour', title: 'Virtual Tour', icon: Compass, component: FacilitiesTourForm }
];

export default function FacilitiesForm({ apiBase, activeTab }) {
  const getInitialTab = () => {
    if (activeTab === 'cms-fac-overview-details' || activeTab === 'overview-details') return 'overview-details';
    if (activeTab === 'cms-fac-tech-details' || activeTab === 'tech-details') return 'tech-details';
    if (activeTab === 'cms-fac-overview' || activeTab === 'cms-fac-list') return 'overview';
    if (activeTab === 'cms-fac-tech') return 'tech';
    if (activeTab === 'cms-fac-safety') return 'safety';
    if (activeTab === 'cms-fac-gallery') return 'gallery';
    if (activeTab === 'cms-fac-tour') return 'tour';
    return 'hero';
  };

  const [currentTab, setCurrentTab] = useState(getInitialTab);

  useEffect(() => {
    setCurrentTab(getInitialTab());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const activeTabConfig = TABS.find(t => t.id === currentTab) || TABS[0];
  const ActiveComponent = activeTabConfig.component;

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.id === currentTab;

          return (
            <button
              key={tab.id}
              type="button"
              className={`tab-pill-btn ${isActive ? 'active' : ''}`}
              onClick={() => setCurrentTab(tab.id)}
            >
              <Icon className="w-4 h-4 mr-2" />
              <span>{tab.title}</span>
            </button>
          );
        })}
      </div>

      {/* Render Active Section Sub-Form */}
      <div className="unified-tab-content">
        <ActiveComponent apiBase={apiBase} />
      </div>
    </div>
  );
}
